import { LocaleStatus } from '@wix/ambassador-linguist-web-proxy/http';
import { LocaleVisibility } from '@wix/ambassador-multilingual-locales-v2-locale/types';
import { LanguageStatus } from '../types';
import { Flag as LocaleFlag, LanguageCode as ServerLocaleLanguageCode, LanguageCode, RegionCode as LocaleRegionCode, Script as LocaleScript, AutoTranslate } from '@wix/ambassador-linguist-web-proxy/types';
import { getSupportedLanguagesMap } from '../supportedLanguages';
const localeLanguageStatusMap = {
  [LocaleStatus.ACTIVE]: LanguageStatus.ACTIVE,
  [LocaleStatus.INACTIVE]: LanguageStatus.INACTIVE,
  [LanguageStatus.ACTIVE]: LocaleStatus.ACTIVE,
  [LanguageStatus.INACTIVE]: LocaleStatus.INACTIVE,
  [LocaleStatus.UNDEFINED_STATUS]: LocaleStatus.UNDEFINED_STATUS
};
export const convertLocaleToLanguage = locale => {
  if (!locale.id || !locale.languageCode || !locale.format || !locale.status || !locale.flag) {
    throw new Error('invalid locale, missing field');
  }
  const supportedLanguages = getSupportedLanguagesMap();
  const supportedLanguageByLocale = supportedLanguages.get(locale.id.toLowerCase()); // TODO: remove toLocaleLowerCase once we move to LocaleV2 completely

  if (!supportedLanguageByLocale) {
    console.error(`can not find supported language by given locale ${locale.id}`);
    return undefined;
  }
  const primary = locale.status === LocaleStatus.DEFAULT;
  const {
    name,
    machineTranslationLanguageCode,
    localizedName
  } = supportedLanguageByLocale;

  // Only translation languages have status
  const status = primary ? undefined : localeLanguageStatusMap[locale.status];
  return {
    id: locale.id,
    code: locale.languageCode,
    languageCode: locale.languageCode,
    locale: locale.format,
    primary,
    status,
    countryCode: locale.flag,
    name,
    autoTranslate: locale.autoTranslate,
    machineTranslationLanguageCode,
    regionCode: locale.regionCode,
    script: locale.script,
    localizedName
  };
};
export function convertLanguageToLocale(language) {
  return {
    autoTranslate: language.autoTranslate,
    id: language.id,
    languageCode: ServerLocaleLanguageCode[language.languageCode || language.code],
    format: language.locale,
    flag: language.countryCode ? LocaleFlag[language.countryCode] : LocaleFlag.UNDEFINED_FLAG_CODE,
    status: language.primary ? LocaleStatus.DEFAULT : localeLanguageStatusMap[language.status || LocaleStatus.UNDEFINED_STATUS],
    regionCode: language.regionCode || LocaleRegionCode.UNDEFINED_REGION_CODE,
    script: language.script || LocaleScript.UNDEFINED_SCRIPT
  };
}
export function convertLanguageToLocaleV2(language) {
  const languageCode = language.languageCode || language.code;
  return {
    id: language.id,
    languageCode: languageCode === LanguageCode.UNDEFINED_LANGUAGE_CODE ? undefined : languageCode,
    regionCode: language.regionCode === LocaleRegionCode.UNDEFINED_REGION_CODE ? undefined : language.regionCode,
    regionalFormat: language.locale,
    visibility: language.status === LanguageStatus.ACTIVE ? LocaleVisibility.VISIBLE : LocaleVisibility.HIDDEN,
    machineTranslationCode: language.machineTranslationLanguageCode,
    flag: language.countryCode,
    primaryLocale: language.primary,
    effectiveDisplayName: language.localizedName,
    visitorPrimaryLocale: language.isDefaultViewed
  };
}
export const convertLocaleV2ToLanguage = locale => {
  const status = locale.primaryLocale ? undefined : locale.visibility === LocaleVisibility.VISIBLE ? localeLanguageStatusMap[LocaleStatus.ACTIVE] : localeLanguageStatusMap[LocaleStatus.INACTIVE];
  return {
    id: locale.id || '',
    code: locale.languageCode,
    locale: locale.regionalFormat || '',
    countryCode: locale.flag || '',
    status,
    primary: locale.primaryLocale || false,
    name: locale.effectiveDisplayName || '',
    machineTranslationLanguageCode: locale.machineTranslationCode || '',
    languageCode: locale.languageCode || '',
    regionCode: locale.regionCode,
    localizedName: locale.effectiveDisplayName || '',
    autoTranslate: AutoTranslate.OFF,
    script: LocaleScript.UNDEFINED_SCRIPT,
    isDefaultViewed: locale.visitorPrimaryLocale || false
  };
};
//# sourceMappingURL=languageLocaleConverter.js.map